export const allProducts = [
  {
    id: 1,
    name: '聆聽Pro 3',
    subtitle: '隱形耳道式助聽器',
    price: 35800,
    category: '耳內式',
    tags: ['隱形', 'AI降噪', '防水'],
    image: 'https://readdy.ai/api/search-image?query=modern%20invisible%20in%20the%20ear%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality%20close%20up%20shot&width=400&height=400&seq=1&orientation=squarish',
    description: '超微型設計，隱藏於耳道深處，旁人幾乎無法察覺。搭載第三代 AI 降噪晶片，自動識別環境噪音並調整音質，讓對話更清晰自然。',
  },
  {
    id: 2,
    name: '富聆Elite X',
    subtitle: '耳掛式智能助聽器',
    price: 49800,
    category: '耳掛式',
    tags: ['智能調節', '藍牙', 'App控制'],
    image: 'https://readdy.ai/api/search-image?query=modern%20behind%20the%20ear%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality%20close%20up%20shot&width=400&height=400&seq=2&orientation=squarish',
    description: '旗艦級耳掛式助聽器，內建環境智能分析系統，可透過手機 App 即時調整音質設定。支援藍牙串流，直接接聽電話與音樂。',
  },
  {
    id: 3,
    name: '清晰Plus 5',
    subtitle: '充電式助聽器',
    price: 28800,
    category: '充電式',
    tags: ['充電式', '長續航', '入門首選'],
    image: 'https://readdy.ai/api/search-image?query=rechargeable%20hearing%20aid%20device%20with%20charging%20dock%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality&width=400&height=400&seq=3&orientation=squarish',
    description: '告別換電池的困擾，充電盒設計讓助聽器每晚自動充電，一次充電可使用一整天。操作簡單，是長輩入門的最佳選擇。',
  },
  {
    id: 4,
    name: '守護Mini 2',
    subtitle: '迷你耳內式助聽器',
    price: 42800,
    category: '耳內式',
    tags: ['迷你', '輕巧', '舒適'],
    image: 'https://readdy.ai/api/search-image?query=mini%20in%20the%20ear%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality%20close%20up&width=400&height=400&seq=4&orientation=squarish',
    description: '業界最小耳內式助聽器，重量僅 1.8 克。採用醫療級矽膠材質，長時間佩戴依然舒適。適合輕度至中度聽損者。',
  },
  {
    id: 5,
    name: '聆悅Comfort',
    subtitle: '舒適型耳掛助聽器',
    price: 32800,
    category: '耳掛式',
    tags: ['舒適', '耐用', '防汗'],
    image: 'https://readdy.ai/api/search-image?query=comfortable%20behind%20the%20ear%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality&width=400&height=400&seq=5&orientation=squarish',
    description: '人體工學設計的耳掛弧度，搭配柔軟耳模，長時間佩戴不疲勞。防汗材質適合運動與戶外活動。',
  },
  {
    id: 6,
    name: '智能Link Pro',
    subtitle: '藍牙連線助聽器',
    price: 55800,
    category: '藍牙式',
    tags: ['藍牙5.0', '串流音訊', '雙耳同步'],
    image: 'https://readdy.ai/api/search-image?query=bluetooth%20connected%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality%20close%20up&width=400&height=400&seq=6&orientation=squarish',
    description: '藍牙 5.0 技術，支援雙耳同步串流。無論接聽電話、觀看影片或聽音樂，都能獲得立體聲效果。適合對科技接受度高的用戶。',
  },
  {
    id: 7,
    name: '親聽Baby',
    subtitle: '兒童專用助聽器',
    price: 39800,
    category: '耳掛式',
    tags: ['兒童專用', '耐摔', '色彩豐富'],
    image: 'https://readdy.ai/api/search-image?query=colorful%20hearing%20aid%20device%20for%20children%20product%20photography%20on%20soft%20cream%20white%20background%20playful%20friendly%20design%20minimalist%20professional%20lighting%20high%20quality&width=400&height=400&seq=7&orientation=squarish',
    description: '專為兒童設計的助聽器，外殼堅固耐摔，提供多種繽紛色彩選擇。內建成長型音量調節，可隨著兒童聽力發展自動調整。',
  },
  {
    id: 8,
    name: '穩聽Power',
    subtitle: '重度聽損專用',
    price: 46800,
    category: '耳掛式',
    tags: ['大功率', '重度聽損', '反饋抑制'],
    image: 'https://readdy.ai/api/search-image?query=powerful%20hearing%20aid%20device%20for%20severe%20hearing%20loss%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality&width=400&height=400&seq=8&orientation=squarish',
    description: '專為重度聽損設計的大功率助聽器，最大增益達 82dB。先進反饋抑制技術，消除惱人的嘯叫聲。',
  },
  {
    id: 9,
    name: '簡聽Easy',
    subtitle: '一鍵操作助聽器',
    price: 22800,
    category: '耳掛式',
    tags: ['簡易操作', '一鍵', '經濟實惠'],
    image: 'https://readdy.ai/api/search-image?query=simple%20hearing%20aid%20device%20with%20one%20button%20operation%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality&width=400&height=400&seq=9&orientation=squarish',
    description: '只有一個按鈕，長按開關、短按切換模式。沒有複雜設定，長輩也能輕鬆上手。高性價比之選。',
  },
];

export const productCategories = ['全部', '耳內式', '耳掛式', '充電式', '藍牙式'];